<template>
    <structure>
        <div class="teste" style="width: 600px">
            <div>
                <strong>Dados Selecionados:</strong> {{form.dados1}}
            </div>
            <br>
            <br>
            <br>
            <br>
            <ui-select-2 :options="options1" v-model="form.dados1"  remove-selected-item :limite="1" /> 
        </div>
    </structure>
</template>

<script>
    //
    import structure from '@/templates/private'
    import { uiSelect2 } from '@/components'
    export default {
        name: 'users',
        components: { structure, uiSelect2 },
        data() {
            return {
                form: {
                    dados: [
                        'Carlos',
                        'Benício',
                        'Daniel'
                    ],
                    dados2: [
                        'B2',
                        'A1',
                    ],
                    dados3: [
                        'gf',
                        'al'
                    ],
                },
                options1: [
                    'Carlos',
                    'Benício',
                    'Ana',
                    'Daniel',
                    'Eduardo',
                    'Franklin',
                    'Gabriel',
                ],
                options2: [
                    {
                        label: 'Beatriz',
                        value: 'B2'
                    },
                    {
                        label: 'Camila',
                        value: 'C3'
                    },
                    {
                        label: 'Ana',
                        value: 'A1'
                    }
                ],
                options3: [
                    {
                        title: 'Diretores',
                        items: [
                            {
                                label: 'Glauco Farnezi',
                                value: 'gf'
                            },
                            {
                                label: 'Orlando Lacerda',
                                value: 'ol'
                            }
                        ]
                    },
                    {
                        title: 'Back-End',
                        items: [
                            {
                                label: 'Helio',
                                value: 'he'
                            },
                            {
                                label: 'Dennilson',
                                value: 'de'
                            },
                            {
                                label: 'Alefe',
                                value: 'al'
                            }
                           
                        ]
                    },
                    {
                        title: 'Front-End',
                        items: [
                           
                            {
                                label: 'Paulo',
                                value: 'pa'
                            },
                            {
                                label: 'Christopher',
                                value: 'ch'
                            },
                            {
                                label: 'Nikson',
                                value: 'ni'
                            }
                        ]
                    }
                ],
                
            }
        },
        computed: {
        },       
        methods: {
            
        },
        mounted() {
            
        }
    }
</script>

<style lang="stylus" scoped>
    @import 'styles.styl';
</style>

